import React, {useState} from "react";
import {useForm} from "react-hook-form";
import AdvertisementFields from "./AdvertisementFields";

export default function () {
  const {register, handleSubmit, reset, control, watch} = useForm();
  const [errors, setErrors] = useState({});
  const [data, setData] = useState({});
  const advertisementFields = <AdvertisementFields {...{register, errors, control, watch, data}} />;

  return {
    setErrors,
    advertisementFields,
    handleSubmit,
    setData,
    reset,
  }
}